import { render, staticRenderFns } from "./TitleBarMain.vue?vue&type=template&id=c67b8cba&scoped=true&"
import script from "./TitleBarMain.vue?vue&type=script&lang=js&"
export * from "./TitleBarMain.vue?vue&type=script&lang=js&"
import style0 from "./TitleBarMain.vue?vue&type=style&index=0&id=c67b8cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b8cba",
  null
  
)

export default component.exports